// src/zapi-action/action-extension/action-extension-types.ts
var ACTION_EXTENSION_TYPES = Object.freeze({
  LAMBDA: "LAMBDA",
  SQS: "SQS",
  HTTP_PROXY: "HTTP_PROXY"
});

// src/zapi-target.ts
import { oz } from "@vy/utils";
var ZAPI_TARGETS = Object.freeze({
  HTTP_CLIENT: "httpClient",
  AWS_APIGATEWAY: "awsApigateway",
  EXTERNAL_AWS_APIGATEWAY: "externalAwsApigateway",
  DOCUMENTATION: "documentation"
});
var ZapiTargetSchema = oz.nativeEnum(ZAPI_TARGETS);

// src/path-access-level.ts
var PATH_ACCESS_LEVELS = Object.freeze({
  PUBLIC: "public",
  PRIVATE: "private"
});

// src/dynamic-paths-creator-types/dynamic-path-operation.ts
var DYNAMIC_PATH_OPERATIONS = Object.freeze({
  GET: "get",
  LIST: "list",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete"
});

// src/action-method.ts
var ACTIONS_METHODS = Object.freeze({
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
  PATCH: "patch",
  HEAD: "head",
  OPTIONS: "options"
});
var ACTION_METHOD_VALUES = Object.values(ACTIONS_METHODS);

// src/zapi-output-format.ts
var ZAPI_OUTPUT_FORMATS = Object.freeze({
  JSON: "json",
  YML: "yml"
});

// src/pick-with-metadata.ts
import { getRequiredObjectProperty, isNullOrUndefined, oz as oz2 } from "@vy/utils";
function pickWithMetadata(schema, metadata) {
  const pickedKeys = Object.keys(metadata);
  const newObject = pickedKeys.reduce(
    (acc, key) => {
      if (isNullOrUndefined(metadata[key])) {
        return acc;
      }
      const openapiMetadata = getRequiredObjectProperty(metadata, key);
      return acc.extend({
        [key]: schema.shape[key].openapi(openapiMetadata)
      });
    },
    oz2.object({})
  );
  return newObject;
}

// src/paginated-response.ts
import { createdEntities } from "@vy/types";
import { oz as oz4 } from "@vy/utils";

// src/pagination-metadata-schema.ts
import { oz as oz3 } from "@vy/utils";
var PaginationMetadataSchema = oz3.object({
  total: oz3.number(),
  hasMore: oz3.boolean(),
  nextCursor: oz3.string().optional()
});

// src/paginated-response.ts
function paginatedResponse(entity, pluralName) {
  return oz4.object({
    [pluralName]: createdEntities(entity)
  }).merge(PaginationMetadataSchema);
}

// src/deleted-response.ts
import { deleted } from "@vy/types";
import { oz as oz5 } from "@vy/utils";
function deletedResponse(entity, name) {
  return oz5.object({
    [name]: deleted(entity)
  });
}

// src/created-entity-response.ts
import { created } from "@vy/types";
import { oz as oz6 } from "@vy/utils";
function createdEntityResponse(entity, name) {
  return oz6.object({
    [name]: created(entity)
  });
}

// src/pagination-cursor-schema.ts
import { oz as oz7 } from "@vy/utils";
var CursorSchema = oz7.string().optional();

// src/pagination-limit-schema.ts
import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE } from "@vy/types";
import { oz as oz8 } from "@vy/utils";
var PaginationLimitSchema = oz8.coerce.number().min(1).max(MAX_PAGE_SIZE).optional().default(DEFAULT_PAGE_SIZE);

// src/paginated-params-map.ts
function paginatedParamsMap(otherParams) {
  return {
    ...otherParams,
    limit: {
      name: "limit",
      location: "query",
      schema: PaginationLimitSchema,
      metadata: {
        description: "The maximum number of items to return"
      }
    },
    cursor: {
      name: "cursor",
      location: "query",
      schema: CursorSchema,
      metadata: {
        description: "The cursor to use for pagination"
      }
    }
  };
}

// src/update-request.ts
function updateRequest(entity) {
  return entity.partial().strict();
}
export {
  ACTIONS_METHODS,
  ACTION_EXTENSION_TYPES,
  ACTION_METHOD_VALUES,
  CursorSchema,
  DYNAMIC_PATH_OPERATIONS,
  PATH_ACCESS_LEVELS,
  PaginationLimitSchema,
  ZAPI_OUTPUT_FORMATS,
  ZAPI_TARGETS,
  ZapiTargetSchema,
  createdEntityResponse,
  deletedResponse,
  paginatedParamsMap,
  paginatedResponse,
  pickWithMetadata,
  updateRequest
};
